import { useRef, useState } from 'react';

/** Lo que acepta el selector de archivos para los reportes que van a la cola. */
const ACCEPT_REPORTES = 'application/pdf,image/*,.xlsx,.xls';

/** Segunda línea por defecto: el camino de los PDFs (R2 → Gemini → cola). */
const SUB_COLA =
  'Se suben a R2 y se extraen con Gemini automáticamente (en cola); luego quedan en la cola de revisión para confirmar.';

export function UploadDropzone({
  onFiles,
  busy,
  hint,
  sub = SUB_COLA,
  // .xlsx incluido por defecto: aunque el tipo seleccionado sea un PDF, soltar
  // el libro de cuentas aquí lo enruta igual. Sin esto el selector lo muestra
  // en gris y "no pasa nada".
  accept = ACCEPT_REPORTES,
  multiple = true,
}: {
  onFiles: (files: File[]) => void;
  busy: boolean;
  /** Texto principal (depende del tipo de reporte seleccionado). */
  hint?: string;
  /** Segunda línea: a dónde va lo que se suelte aquí. */
  sub?: string;
  accept?: string;
  multiple?: boolean;
}) {
  const [over, setOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  function pick(list: FileList | null) {
    if (!list || list.length === 0) return;
    onFiles(Array.from(list));
    // Limpiar el input: si no, volver a elegir EL MISMO archivo no dispara
    // 'change' y la subida parece "no hacer nada" (reintento tras un fallo).
    if (inputRef.current) inputRef.current.value = '';
  }

  return (
    <div
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        pick(e.dataTransfer.files);
      }}
      onClick={() => inputRef.current?.click()}
      className={`cursor-pointer rounded-xl border-2 border-dashed p-10 text-center transition ${
        over ? 'border-blue-500 bg-blue-950/30' : 'border-slate-600 bg-slate-800/40'
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        hidden
        onChange={(e) => pick(e.target.files)}
      />
      <p className="text-slate-300">
        {busy ? 'Subiendo…' : (hint ?? 'Arrastra aquí los PDFs del Manager-Flash o haz clic')}
      </p>
      <p className="mt-1 text-sm text-slate-500">{sub}</p>
    </div>
  );
}
